import {GlobalApplicationState} from '~/redux/reducers/RootReducer';
import {ProductMetaDataState} from '~/redux/reducers/ProductMetaDataReducer';

export const selectProductMetaData = ({
    productMetaData,
}: GlobalApplicationState): ProductMetaDataState => productMetaData;

export const selectUniqueBrandsInCatalog = ({productMetaData}: GlobalApplicationState): string[] =>
    productMetaData.brandOptions;

export const selectBrandTreezBrands = ({productMetaData}: GlobalApplicationState): string[] =>
    productMetaData.officialBrandOptions;

export const selectUniqueProductFlavors = ({productMetaData}: GlobalApplicationState): string[] =>
    productMetaData.flavorAttributesOptions;

export const selectUniqueProductEffects = ({productMetaData}: GlobalApplicationState): string[] =>
    productMetaData.effectAttributesOptions;

export const selectUniqueGeneralAttributes = ({
    productMetaData,
}: GlobalApplicationState): string[] => productMetaData.generalAttributesOptions;

export const selectUniqueProductIngredients = ({
    productMetaData,
}: GlobalApplicationState): string[] => productMetaData.ingredientAttributesOptions;
